module.exports = __webpack_public_path__ + "static/media/Bills_header_scan.bad7734c.svg";